<template>
  <div v-if="!disabled" :class="{ 'is-mobile': isMobile }" :style="getStyle" class="accumulation-body relative mt-2">
    <info-header :activity-data="activityData" :model="model" :current-number="currentNumber" :timeout-string="sTime" :currency-label="currencyLabel" />
    <div ref="content" class="accumulation-body__content">
      <template v-if="controlVisible">
        <div :class="{ 'is-disabled': prevDisabled }" class="prev control-btn" @click="handlePrev">
          <i class="el-icon-arrow-left"/>
        </div>
        <div :class="{ 'is-disabled': nextDisabled }" class="next control-btn" @click="handleNext">
          <i class="el-icon-arrow-right"/>
        </div>
      </template>
      <div :style="scrollStyle" class="scroll-list" :class="{ 'mx-auto': !controlVisible && !isMobile }">
        <div v-for="(item, index) in list" :key="index" :ref="`item-${index}`" :class="{ 'is-active': item.active }" class="item">
          <bg-style :bg="model.cardBackground" :radius="model.cardRadius" class="w-full card" @click.native.stop="handleItemClick(item)">
            <bg-style :bg="model.logoBackground" class="thumb relative">
              <img :src="item.cover || item.thumb" alt="" class="relative"/>
              <div v-if="!item.cover && !model.detailVisible" class="relative number">
                <span>X</span>{{ item.gift_list[0].num }}
              </div>
            </bg-style>
            <div class="info-area relative">
              <div v-if="model.detailVisible" class="mx-auto w-full overflow-auto">
                <div class="gifts gap-2">
                  <div v-for="(gift, giftIndex) in item.gift_list" :key="giftIndex" class="pack flex items-center flex-shrink-0">
                    <img :src="gift.gift_goods_logo" alt="" class="icon"/>
                    <i class="el-icon-close font-bold"/>
                    <span>{{ gift.num }}</span>
                  </div>
                </div>
              </div>
              <bg-style v-if="item.level_status === 3" :bg="model.disabledBackground" :radius="model.cardRadius" class="handle" @click.native.stop>
                <span class="relative disabled-text">{{ $t('siteBuild.activity.haveGet') }}</span>
              </bg-style>
              <bg-style v-if="item.level_status === 2" :bg="model.getBackground" :radius="model.cardRadius" class="handle" @click.native.stop="handlePick(item)">
                <span class="relative get-text">{{ $t('siteBuild.activity.get') }}</span>
              </bg-style>
              <bg-style v-if="item.level_status === 1" :bg="model.disabledBackground" :radius="model.cardRadius" class="handle" @click.native.stop>
                <span class="relative disabled-text">{{ $t('siteBuild.activity.notQualified') }}</span>
              </bg-style>
            </div>
          </bg-style>
          <div class="circle z-10 relative"/>
          <div class="number">{{ item.virtual_currency_val }}</div>
        </div>
        <bg-style :bg="model.progressBackground" class="progress">
          <bg-style :bg="model.innerBackground" :style="{ width: progressWidth }" class="inner relative h-full"/>
        </bg-style>
      </div>
    </div>
  </div>
</template>

<script>
import {Empty} from "element-ui"
import InfoHeader from './header.vue'
import accumulationMixins from "~/mixins/accumulationMixins.js";
import Bus from "~/site/model/bus";

export default {
  name: 'AccumulationWidgetContent',
  components: {
    [Empty.name]: Empty,
    InfoHeader
  },
  mixins: [accumulationMixins],
  props: {
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      scrollNumber: 0,
      currentRow: {},
      viewNumber: 7
    }
  },
  computed: {
    controlVisible() {
      return this.list.length > this.viewNumber
    },
    scrollStyle() {
      const left = (160 + 51) * this.scrollNumber
      return {
        transform: `translateX(-${left}px)`
      }
    },
    maxScrollNumber() {
      return this.list.length - this.viewNumber
    },
    prevDisabled() {
      return this.scrollNumber === 0
    },
    nextDisabled() {
      return this.scrollNumber === this.maxScrollNumber
    }
  },
  watch: {
    isMobile() {
      const timer = setTimeout(() => {
        this.renderProgress()
        this.resetScroll()
        clearTimeout(timer)
      }, 500)
    },
    bizId(n, o) {
      if (n !== o) {
        this.resetScroll()
        this.init()
      }
    }
  },
  mounted() {
    this.init()
    Bus.$on('reloadActivity', () => {
      this.init()
    })
  },
  methods: {
    async init() {
      this.getViewNumber()
      await this.getActivityData()
      await this.locationAvailableItem()
    },
    resetScroll() {
      this.scrollNumber = 0
      const $content = this.$refs.content
      $content && $content.scrollTo({
        left: 0,
        behavior: 'instant'
      })
    },
    handlePrev() {
      const number = this.scrollNumber - 1
      if (number >= 0) {
        this.scrollNumber -= 1
      }
    },
    handleNext() {
      const number = this.scrollNumber + 1
      if (number <= this.maxScrollNumber) {
        this.scrollNumber += 1
      }
    },
    getViewNumber() {
      if (this.disabled) return
      this.viewNumber = 6
    }
  }
}
</script>

<style lang="less">
.accumulation-body {
  &__header {
    color: var(--text-color);
    font-size: 18px;
    .amount-box {
      color: var(--amount-color);
    }
  }
  &__content {
    width: 100%;
    margin-top: 20px;
    overflow-x: hidden;
    padding-bottom: 10px;
    position: relative;
    &::-webkit-scrollbar {
      height: 0;
      display: none;
    }
    .scroll-list {
      display: flex;
      gap: 51px;
      width: max-content;
      transition: all 0.36s ease;
      position: relative;
      .progress {
        position: absolute !important;
        width: 100%;
        left: 0;
        height: 16px;
        bottom: 35px;
        border: 2px solid var(--progress-bg);
        border-radius: 16px;
        overflow: hidden;
      }

      .item {
        width: 160px;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        position: relative;
        flex-shrink: 0;

        &:last-of-type {
          .progress {
            width: 100%;
          }
        }

        .circle {
          width: 32px;
          height: 32px;
          background: var(--circle-background);
          border-radius: 100%;
          border: 2px solid var(--progress-bg);
          margin-top: 20px;
          position: relative;
          &:after {
            content: "";
            position: absolute;
            width: 32.5px;
            background: var(--progress-bg);
            height: 12px;
            top: 8px;
            left: -2px;
          }
        }

        .number {
          font-size: 18px;
          font-weight: bold;
          color: var(--circle-background);
        }

        .card {
          box-shadow: 2px 0 5px 0 rgba(0, 0, 0, 0.08);
          cursor: pointer;
          border-radius: var(--card-border-radius-px);
          overflow: hidden;

          .thumb {
            width: 100%;
            height: 140px;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
            overflow: hidden;

            img {
              max-height: 95px;
              max-width: 95px;
              transition: all 0.24s ease;
            }
            .number {
              font-size: 20px;
              font-weight: bold;
              color: var(--text-color);
              span {
                font-size: 16px;
              }
            }
          }

          .day {
            color: var(--text-color);
          }

          .info-area {
            width: 100%;
            padding: 20px 10px;

            .gifts {
              display: flex;
              margin: 0 auto;
              overflow: auto;
              max-width: 100%;
              white-space: nowrap;
              color: var(--text-color);
              flex-wrap: nowrap;
              min-height: 40px;
              padding-bottom: 10px;
              .icon {
                width: 30px;
                height: 30px;
              }
              .pack {
                font-size: 14px;
                &:first-of-type {
                  margin: 0 auto;
                }
              }
              &::-webkit-scrollbar {
                height: 0;
              }
            }

            .handle {
              line-height: 46px;
              width: 100%;
              color: var(--button-text-color);
              span {
                text-align: center;
                width: 100%;
                display: block;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                font-size: 20px;
                font-weight: bold;
              }
              .get-text {
                color: var(--get-text-color);
              }
              .disabled-text {
                color: var(--disabled-text-color);
              }
            }
          }
        }

        &.is-active {
          div.circle {
            background: var(--progress-inner-color);
            &:after {
              content: "";
              background: var(--progress-inner-color);
            }
          }
          .number {
            color: var(--text-color);
          }
        }
      }
    }

    .control-btn {
      position: absolute;
      width: 54px;
      height: 54px;
      background-color: rgba(0, 0, 0, 0.1);
      border-radius: 100%;
      top: 80px;
      z-index: 10;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      display: flex;
      transition: all 0.24s ease;
      opacity: 0;
      pointer-events: none;

      i {
        font-size: 24px;
        color: white;
        font-weight: bold;
      }

      &.prev {
        left: 12px;
      }

      &.next {
        right: 12px;
      }

      &.is-disabled {
        opacity: 0 !important;
        pointer-events: none;
        cursor: default;
      }

      &:hover {
        background-color: white;
        box-shadow: 2px 0 5px 0 rgba(0, 0, 0, 0.08);

        i {
          color: black;
        }
      }
    }

    &:hover {
      .control-btn {
        opacity: 1;
        pointer-events: all;
      }
    }
  }

  &.is-mobile {
    padding: 0 5px;
    .accumulation-body__header {
      font-size: 14px;
      padding: 0 11px;
      .time {
        margin-right: 16px;
      }
    }

    .accumulation-body__content {
      overflow-x: auto;
      .control-btn {
        display: none !important;
      }

      .scroll-list {
        padding-left: 0;
        gap: 10px;
        .progress {
          width: 100%;
          height: 10px;
          bottom: 32px;
          left: 0;
        }
      }

      .item {
        width: 100px;
        .card {
          .info-area {
           .gifts {
            min-height: 30px;
             .icon {
               width: 20px;
               height: 20px;
             }
             .pack {
               font-size: 12px;
             }
           }
          }
        }
        .thumb {
          height: 84px;
          img {
            max-width: 50px;
            max-height: 50px;
          }
          .number {
            font-size: 14px;
            span {
              font-size: 10px;
            }
          }
        }

        .circle {
          height: 18px;
          width: 18px;
          border: 2px solid var(--progress-bg);
          margin-bottom: 5px;
          margin-top: 10px;
          &:after {
            width: 18.5px;
            height: 6px;
            top: 5px;
            left: -2px;
          }
        }

        .number {
          font-size: 16px;
        }

        .info-area {
          padding: 10px 5px;

          .handle {
            line-height: 24px;
            span {
              font-size: 12px;
            }
          }
        }
      }
    }
  }
}
</style>
